<!--
 * @Author: Junjie
 * @Date: 2022-05-21 14:43:47
 * @LastEditTime: 2022-05-21 14:49:36
 * @email: 781433561@qq.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/views/monitor/model/ModelList.vue
-->

<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="模型名称">
              <a-input placeholder="数字模型名称" v-model="queryParam.model_name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="模型类型" v-model="queryParam.model_type">
              <a-select>
                <a-select-option value="=">设备</a-select-option>
                <a-select-option value="!=">工艺</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleExportXls('iot_alert_list')" icon="download" type="primary">导出</a-button>

      <a-tooltip title="卡片模式" v-show="!cardType">
        <a-button @click="cardType = true;" icon="credit-card" style="margin-left: 20px"></a-button>
      </a-tooltip>

      <a-tooltip title="表格模式" v-show="cardType">
        <a-button @click="cardType = false;" icon="table" style="margin-left: 20px" v-show="cardType"></a-button>
      </a-tooltip>
    </div>

    <div v-show="!cardType">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary">下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="acknowledgement(record)">确认</a>
          <a-divider type="vertical" />
          <a @click="acknowledgement(record)">转工单</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">忽略</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="devDetail(record)">设备详情</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="dataLine(record)">数据曲线</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="toOtherPage('/general/process')">工艺看板</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <div v-show="cardType">
      <a-list :dataSource="dataSource" :grid="{ gutter: 24, lg: 4, md: 2, sm: 1, xs: 1 }">
        <a-list-item slot="renderItem" slot-scope="item, index">
          <a-card
            :headStyle="{ 'text-align': 'center' }"
            :hoverable="true"
            :title="item.alertName || '告警'"
            size="small"
          >
            <img :src="index % 2 === 0 ? devDefaulPng : processDefaulPng" alt="告警设备" slot="cover" />
            <a-card-meta :description="item.summary" :title="item.alertTime"></a-card-meta>
            <template class="ant-card-actions" slot="actions">
              <a>
                <a-button size="small" type="link">确认</a-button>
              </a>
              <a>
                <a-button size="small" type="link">转工单</a-button>
              </a>
              <a>
                <a-dropdown>
                  <a class="ant-dropdown-link">
                    <a-icon type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a-button size="small" type="link">忽略</a-button>
                    </a-menu-item>
                    <a-menu-item>
                      <a-button @click="devDetail(item)" size="small" type="link">设备详情</a-button>
                    </a-menu-item>
                    <a-menu-item>
                      <a-button @click="dataLine(item)" size="small" type="link">数据曲线</a-button>
                    </a-menu-item>
                    <a-menu-item>
                      <a-button @click="toOtherPage('/general/process')" size="small" type="link">工艺看板</a-button>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a>
            </template>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import devDefaulPng from '@/assets/dev.png'
  import processDefaulPng from '@/assets/process.jpg'
  import moment from 'dayjs'
  export default {
    name: 'ModelList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {

    },
    data () {
      return {
        devDefaulPng: devDefaulPng,
        processDefaulPng: processDefaulPng,
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '小组编号',
            align: 'center',
            dataIndex: 'groupId'
          },
          {
            title: '预警分组编号',
            align: 'center',
            dataIndex: 'alertGroupId'
          },
          {
            title: '小组名称',
            align: 'center',
            dataIndex: 'groupName'
          },
          {
            title: '告警名称',
            align: 'center',
            dataIndex: 'alertName'
          },
          {
            title: '规则id',
            align: 'center',
            dataIndex: 'ruleId'
          },
          {
            title: '测点点号',
            align: 'center',
            dataIndex: 'pointCode'
          },
          {
            title: '传感器Sn码',
            align: 'center',
            dataIndex: 'devId'
          },
          {
            title: '供水流域id',
            align: 'center',
            dataIndex: 'processId'
          },
          {
            title: '告警时间',
            align: 'center',
            dataIndex: 'alertTime',
            customRender: function (text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '告警信息',
            align: 'center',
            dataIndex: 'summary'
          },
          {
            title: '告警分类',
            align: 'center',
            dataIndex: 'alertType'
          },
          {
            title: '附件',
            align: 'center',
            dataIndex: 'attachment'
          },
          {
            title: '预警等级',
            align: 'center',
            dataIndex: 'alertLevel_dictText'
          },
          {
            title: '是否被处理',
            align: 'center',
            dataIndex: 'isAcknowledgement_dictText'
          },
          {
            title: '处理方式',
            align: 'center',
            dataIndex: 'disposal_dictText'
          },
          {
            title: '是否恢复',
            align: 'center',
            dataIndex: 'isRecovery_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/alert/iotAlert/list',
          delete: '/alert/iotAlert/delete',
          deleteBatch: '/alert/iotAlert/deleteBatch',
          exportXlsUrl: '/alert/iotAlert/exportXls',
          importExcelUrl: 'alert/iotAlert/importExcel'

        },
        cardType: true,
        dictOptions: {},
        superFieldList: []
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      devDetail (record) {
        this.$router.push({
          path: '/equipment/account/detail',
          query: {
            accountId: record.id || '1524233466093260802',
            pageType: 'text'
          }
        })
      },
      dataLine (record) {
        this.$router.push({
          path: '/monitor/dataLine',
          query: {
            points: 't_654004000001_d_C1_D3_p_00160140,t_654004000001_d_C1_D3_p_00150138',
            timeRange: [moment(record.alertTime).add(-1, 'hours').format('YYYY-MM-DD HH:mm'), moment(record.alertTime).add(1, 'hours').format('YYYY-MM-DD HH:mm')].join(',')
          }
        })
      },
      acknowledgement (record) {

      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'int', value: 'groupId', text: '小组编号' })
        fieldList.push({ type: 'int', value: 'alertGroupId', text: '预警分组编号' })
        fieldList.push({ type: 'string', value: 'groupName', text: '小组名称' })
        fieldList.push({ type: 'string', value: 'alertName', text: '告警名称' })
        fieldList.push({ type: 'string', value: 'ruleId', text: '规则id' })
        fieldList.push({ type: 'string', value: 'pointCode', text: '测点点号' })
        fieldList.push({ type: 'string', value: 'devId', text: '传感器Sn码' })
        fieldList.push({ type: 'string', value: 'processId', text: '供水流域id' })
        fieldList.push({ type: 'date', value: 'alertTime', text: '告警时间' })
        fieldList.push({ type: 'string', value: 'summary', text: '告警信息' })
        fieldList.push({ type: 'int', value: 'alertType', text: '告警分类(测点采集、视频识别、音频识别)' })
        fieldList.push({ type: 'string', value: 'attachment', text: '附件文件id（图片、视频、音频等）' })
        fieldList.push({ type: 'int', value: 'alertLevel', text: '预警等级' })
        fieldList.push({ type: 'int', value: 'isAcknowledgement;', text: '是否被处理' })
        fieldList.push({ type: 'int', value: 'disposal', text: '处理方式' })
        fieldList.push({ type: 'int', value: 'isRecovery', text: '是否恢复' })
        this.superFieldList = fieldList
      },
      toOtherPage (route) {
        this.$router.push({
          path: route
        })
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
